/**
 * Wysyła odsłonę przy każdej zmianie route'u.
 *
 * W SPA nawigacja nie przeładowuje dokumentu, więc GTM sam odsłon nie liczy.
 * Pushujemy `spa_pageview` — kontener ma na to trigger (Custom Event) wysyłający
 * page_view do GA4. Tag konfiguracyjny GA4 NIE może przy tym mieć włączonego
 * własnego page_view na All Pages, bo wejście liczyłoby się dwa razy.
 *
 * Nic nie renderuje. Musi siedzieć wewnątrz <BrowserRouter>.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/analytics";

export function RouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    track("spa_pageview", {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
    // Tylko pathname — zmiana samego hasha (np. powrót z OAuth) to nie nowa odsłona.
  }, [location.pathname, location.search]);

  return null;
}
